import React from 'react';
import { Modal, Spinner } from 'react-bootstrap';

// Stages that are not shown while a report is made.
const c_HiddenPdfStages = ['queued'];

// A stage name as the backend stores it, in words: 'recommended_fixes' is shown as 'Recommended Fixes'.
export const format_stage_name = (text)=>{
	if(!text){
		return '';
	}

	return text
		.split('_')
		.map((word)=>{ return word.charAt(0).toUpperCase() + word.slice(1); })
		.join(' ');
};

// The modal shown while a PDF report is generated: a spinner, and the part of the report being made.
function PdfExportModal({show, stage}){
	return (
		<Modal
			show={show}
			backdrop="static"
			centered
			keyboard={false}>
			<Modal.Body className="loading-modal-body">
				<Spinner animation="border" role="status" />
				<div className="modal-running-analysis">
					Generating PDF report...
				</div>

				{(stage && !c_HiddenPdfStages.includes(stage)) && <div className="loading-stage-text">
					{format_stage_name(stage)}
				</div>}
			</Modal.Body>
		</Modal>
	);
}

export default PdfExportModal;
